import type { ActiveTab } from "@/components/aicheck/hooks/useTraceabilityHistory";
import { RunHistoryPanel } from "@/components/aicheck/RunHistoryPanel";
import type { AICheckRunResult } from "@/types/aicheck";

interface HistoryTabProps {
  result: AICheckRunResult;
  activeTab: ActiveTab;
}

/**
 * 「差分・履歴」タブ本体。tabpanel ラッパ + RunHistoryPanel。
 * 表示ゲート（variant !== "project"）は親側に残す。
 * RunHistoryPanel はアクティブ時のみマウントする（元実装の遅延描画を維持）。
 */
export function HistoryTab({ result, activeTab }: HistoryTabProps) {
  return (
    <div
      id="results-panel-history"
      role="tabpanel"
      aria-labelledby="results-tab-history"
      hidden={activeTab !== "history"}
    >
      {activeTab === "history" && (
        <RunHistoryPanel
          projectParam={String(result.projectId)}
          refreshKey={result.completedAt ?? undefined}
        />
      )}
    </div>
  );
}
